export const URL_APP_STORE = "https://itunes.apple.com/app/id1405323394";
